import React, { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { Button, Col, Form, Modal, Row, Table, TableColumnsType } from 'antd';
import Title from 'antd/es/typography/Title';
import { viewTotalCOntribution } from 'app/entities/common/common.reducer';
import { Container } from 'reactstrap';
import { displayPercent } from 'app/shared/util/percent';
import { contributionView } from '../config';

type IAdjustWeightProps = {
  isOpen: boolean;
  onClose: (isReload?: boolean) => void;
  filter: any;
  contributionGroupBy: number;
};

export const TotalContribution = ({ isOpen, onClose, filter, contributionGroupBy }: IAdjustWeightProps) => {
  const dispatch = useAppDispatch();
  const totalContributions = useAppSelector(state => state.common.totalContribution);

  const columns: TableColumnsType<any> = [
    {
      key: 'name',
      dataIndex: 'name',
    },
    {
      key: 'contribution',
      dataIndex: 'contribution',
      render: item => displayPercent(item),
    },
  ];

  useEffect(() => {
    if (filter?.planPeriodId && filter?.adjustmentPeriod >= 0 && contributionGroupBy >= 0) {
      dispatch(
        viewTotalCOntribution({
          adjustmentPeriod: filter?.adjustmentPeriod,
          planPeriodId: filter?.planPeriodId,
          contributionGroupBy,
          accountableId: filter?.accountableId
        }),
      );
    }
  }, [filter, isOpen]);

  const handleClose = (reload = false) => {
    onClose(reload);
  };

  return (
    <Modal
      width={600}
      open={isOpen}
      footer={null}
      onCancel={() => {
        handleClose();
      }}
    >
      <Container className="form">
        <Title level={3}>Tổng tỷ trọng {contributionView[contributionGroupBy].label.toLocaleLowerCase()}</Title>
        <Row>
          <Col md={24}>
            <Form.Item>
              <Table bordered showHeader={false} dataSource={totalContributions} pagination={false} columns={columns} />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item>
          <Row className="action" justify="end">
            <Col>
              <Button
                onClick={() => {
                  handleClose();
                }}
              >
                Hủy
              </Button>
            </Col>
          </Row>
        </Form.Item>
      </Container>
    </Modal>
  );
};

export default TotalContribution;
